function getIndexFromListEnd(items, index) {
  return items.length - index - 1
}

function getThresholdIndexFromListEnd({ items, threshold }) {
  return Math.min(threshold, items.length - 1)
}

export function isThresholdIndex(items, index, threshold) {
  return (
    getIndexFromListEnd(items, index) ===
    getThresholdIndexFromListEnd({ items, threshold })
  )
}
